import { BloqueioDesbloqueioAgendaPrestadorDTO } from "@/api/cadastro/saude/agenda/BloqueioDesbloqueioAgendaPrestadorDTO";
import { BloqueioDesbloqueioAgendaProfissionalDTO } from '@/api/cadastro/saude/agenda/BloqueioDesbloqueioAgendaProfissionalDTO';
import { HorariosDisponiveisDTO } from "@/api/cadastro/saude/HorariosDisponiveisDTO";
import { servicosSaudeAgendaApi } from "@/api/ServicosSaudeAgendaApi";
import { AgendaModel } from "@/models/cadastros/saude/AgendaModel";
import { ConfiguracaoAgendaPrestadorPaginationModel } from "@/models/cadastros/saude/ConfiguracaoAgendaPrestadorPaginationModel";
import { ConfiguracaoAgendaProfissionalPaginationModel } from "@/models/cadastros/saude/ConfiguracaoAgendaProfissionalPaginationModel";
import { PaginationModel } from "@/models/commons/PaginationModel";

class CadastroAgendaService {
  salvarAgendaProfissional(cadastroAgenda: AgendaModel) {
    if (cadastroAgenda.id || (cadastroAgenda.configuracaoAgenda && cadastroAgenda.configuracaoAgenda.id)) {
      return servicosSaudeAgendaApi.atualizarAgendaProfissional(cadastroAgenda);
    } else {
      return servicosSaudeAgendaApi.salvarAgendaProfissional(cadastroAgenda);
    }
  }

  salvarAgendaEspecialidade(cadastroAgenda: AgendaModel) {
    if (cadastroAgenda.id) {
      return servicosSaudeAgendaApi.atualizarAgendaEspecialidade(cadastroAgenda);
    } else {
      return servicosSaudeAgendaApi.salvarAgendaEspecialidade(cadastroAgenda);
    }
  }

  consultarAgendaPrestador(
    paginacao: PaginationModel,
    idPrestador: number,
    idEspecialidade?: number
  ): Promise<ConfiguracaoAgendaPrestadorPaginationModel> {
    return servicosSaudeAgendaApi
      .consultarAgendaPrestador({
        idPrestador,
        idEspecialidade,
        page: paginacao.page ? paginacao.page - 1 : 0,
        size: paginacao.itemsPerPage,
      })
      .then((res) => {
        const configuracaoAgendaPrestadorPaginationModel: ConfiguracaoAgendaPrestadorPaginationModel = {
          conteudo:
            res.content?.map((configuracaoResumidaDTO) => {
              return {
                id: configuracaoResumidaDTO.id,
                nomePrestador: configuracaoResumidaDTO.nomePrestador || "",
                nomeEspecialidade: configuracaoResumidaDTO.nomeEspecialidade || "",
                duracaoAtendimento: configuracaoResumidaDTO.duracaoAtendimento,
              };
            }) || [],
          itemsPerPage: res.size,
          itemsLength: res.totalElements,
          page: paginacao.page,
        };
        return configuracaoAgendaPrestadorPaginationModel;
      });
  }

  consultarAgendaProfissional(
    paginacao: PaginationModel,
    idPrestador: number,
    idProfissional?: number
  ): Promise<ConfiguracaoAgendaProfissionalPaginationModel> {
    return servicosSaudeAgendaApi
      .consultarAgendaProfissional({
        idPrestador,
        idProfissional,
        page: paginacao.page ? paginacao.page - 1 : 0,
        size: paginacao.itemsPerPage,
      })
      .then((res) => {
        const configuracaoAgendaProfissionaPaginationModel: ConfiguracaoAgendaProfissionalPaginationModel = {
          conteudo:
            res.content?.map((configuracaoResumidaDTO) => {
              return {
                id: configuracaoResumidaDTO.id,
                nomePrestador: configuracaoResumidaDTO.nomePrestador || "",
                nomeProfissional: configuracaoResumidaDTO.nomeProfissional || "",
                duracaoAtendimento: configuracaoResumidaDTO.duracaoAtendimento,
              };
            }) || [],
          itemsPerPage: res.size,
          itemsLength: res.totalElements,
          page: paginacao.page,
        };
        return configuracaoAgendaProfissionaPaginationModel;
      });
  }

  obterConfiguracaoAgendaPrestador(idConfiguracaoAgenda: number) {
    return servicosSaudeAgendaApi.obterConfiguracaoAgendaPrestador(idConfiguracaoAgenda).then((res) => {
      res.configuracaoAgenda?.configuracoesPeriodos?.forEach((configuracao) => {
        configuracao.horaFinal = configuracao.horaFinal.substring(0, configuracao.horaFinal.lastIndexOf(":"));
        configuracao.horaInicial = configuracao.horaInicial.substring(0, configuracao.horaInicial.lastIndexOf(":"));
      });
      return res;
    });
  }

  obterConfiguracaoAgendaProfissional(idConfiguracaoAgenda: number) {
    return servicosSaudeAgendaApi.obterConfiguracaoAgendaProfissional(idConfiguracaoAgenda).then((res) => {
      res.configuracaoAgenda?.configuracoesPeriodos?.forEach((configuracao) => {
        configuracao.horaFinal = configuracao.horaFinal.substring(0, configuracao.horaFinal.lastIndexOf(":"));
        configuracao.horaInicial = configuracao.horaInicial.substring(0, configuracao.horaInicial.lastIndexOf(":"));
      });
      return res;
    });
  }

  excluirConfiguracaoAgendPrestadorEspecialidade(idConfiguracaoAgenda: number) {
    return servicosSaudeAgendaApi.excluirConfiguracaoAgendPrestadorEspecialidade(idConfiguracaoAgenda);
  }

  excluirConfiguracaoAgendaProfissional(idConfiguracaoAgenda: number) {
    return servicosSaudeAgendaApi.excluirConfiguracaoAgendaProfissional(idConfiguracaoAgenda);
  }

  obterAgendaProfissional(idProfissional: number, data: string): Promise<HorariosDisponiveisDTO[]> {
    return servicosSaudeAgendaApi.obterHorariosDisponiveisProfissional({
      idProfissional,
      data,
    });
  }

  obterAgendaPrestadorEspecialidade(
    idPrestador: number,
    idEspecialidade: number,
    data: string
  ): Promise<HorariosDisponiveisDTO[]> {
    return servicosSaudeAgendaApi.obterHorariosDisponiveisPrestadorEspecialidade({
      idPrestador,
      idEspecialidade,
      data,
    });
  }

  bloquearAgendaPrestador(idPrestador: number, idEspecialidade: number, data: string, hora: string): Promise<any> {
    return servicosSaudeAgendaApi.bloquearAgendaPrestador(
      new BloqueioDesbloqueioAgendaPrestadorDTO(data, hora, idEspecialidade, idPrestador)
    );
  }

  desbloquearAgendaPrestador(idPrestador: number, idEspecialidade: number, data: string, hora: string): Promise<any> {
    return servicosSaudeAgendaApi.desbloquearAgendaPrestador(
      new BloqueioDesbloqueioAgendaPrestadorDTO(data, hora, idEspecialidade, idPrestador)
    );
  }

  bloquearAgendaProfissional(idProfissional: number, data: string, hora: string): Promise<any> {
    return servicosSaudeAgendaApi.bloquearAgendaProfissional(
      new BloqueioDesbloqueioAgendaProfissionalDTO(data, hora, idProfissional)
    );
  }

  desbloquearAgendaProfissional(idProfissional: number, data: string, hora: string): Promise<any> {
    return servicosSaudeAgendaApi.desbloquearAgendaProfissional(
      new BloqueioDesbloqueioAgendaProfissionalDTO(data, hora, idProfissional)
    );
  }
}

export const cadastroAgendaService = new CadastroAgendaService();
